<template>
  <div>
    <div class="tool_box" v-if="!props.isEdit && !props.editData">
      <a-button
        @click="
          fileExport({
            name: `（业主）车辆预约批量申请Excel模板.xlsx`,
            url: `/api/carApplications/template/getProprietor`,
          })
        "
      >
        业主批量导入模板
      </a-button>
      &nbsp; &nbsp;
      <FileUpload
        :showList="false"
        url="/carApplications/import/proprietor"
        fileField="file"
        @uploadSuccess="bulkImportSuccess"
        @error="bulkImportError"
      >
        <a-button type="primary">业主批量导入</a-button>
      </FileUpload>
      &nbsp; &nbsp;
      <a-button
        @click="
          fileExport({
            name: `（施工）车辆预约批量申请Excel模板.xlsx`,
            url: `/api/carApplications/template/getBuild`,
          })
        "
      >
        施工批量导入模板
      </a-button>
      &nbsp; &nbsp;
      <FileUpload
        :showList="false"
        url="/carApplications/import/build"
        fileField="file"
        @change="bulkImportSuccess"
        @error="bulkImportError"
      >
        <a-button type="primary">施工批量导入</a-button>
      </FileUpload>
    </div>
    <multiple_form
      :forms="forms"
      :edit="props.canEdit"
      :editData="props.editData"
      :disabled="props.disabled"
      :submitBtn="!props.isDetail"
      :disabledDate="disabledDate"
      @submit="handelSubmit"
    />
  </div>
</template>
<script setup>
  import { ref, defineProps, defineEmits, computed, toRefs } from 'vue'
  import { message } from 'ant-design-vue'
  import {
    createData,
    updateData,
  } from '@/api/car_application/enterprise_application'
  import multiple_form from '@/components/multiple_form'
  import { gender, cargoType, areaTypeConst } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  import { fileExport } from '@/utils/download'
  import FileUpload from '@/components/form/file_upload'
  import { useStore } from 'vuex'
  import dayjs from 'dayjs'

  const disabledDate = (current) => {
    return current && current < dayjs().subtract(1,'days').endOf('day')
  }
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    canEdit: {
      default: true,
    },
    editData: Object,
    data: Array,
    idField: String,
    disabled: Boolean,
    isDetail: { type: Boolean, default: false },
  })
  const emit = defineEmits(['submit', 'error', 'change'])
  const showDanger = ref(props.editData?.cargo_type == '1')
  const store = useStore()
  const { carModelObj } = toRefs(store.state?.common)
  const showCargo = ref(
    !!carModelObj.value[props?.editData?.vehicle_type_id]?.show_cargo_type
  )
  const need_record = ref(0)
  const detailNeedRecord = computed(() => {
    return props.editData?.vehicle_type?.need_record!= 1
  })
  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '申请人信息',
      id: 'applicant_information',
      formItem: [
        {
          type: 'input',
          field: 'applicant_name',
          label: '姓名',
        },
        {
          type: 'select',
          field: 'visitor_idcard_type',
          storeOptions: 'documentType',
          label: '证件类型',
        },
        {
          type: 'input',
          field: 'applicant_idcard',
          label: '证件号码',
        },
        {
          type: 'select',
          field: 'applicant_gender',
          options: constantToOptions(gender),
          label: '性别',
        },
        {
          type: 'input',
          field: 'applicant_phone',
          label: '联系电话',
        },
        {
          type: 'input',
          field: 'visitor_company',
          label: '来访单位',
        },
      ],
    },
    {
      name: '车辆信息',
      id: 'vehicle_information',
      formItem: [
        {
          type: 'select',
          field: 'vehicle_type_id',
          label: '车型(行驶证)',
          storeOptions: 'carModel',
          onChange: (e) => {
            showCargo.value = !!carModelObj.value[e]?.show_cargo_type
            need_record.value = carModelObj.value[e]?.need_record
          },
        },
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
        },
        {
          type: 'select',
          field: 'license_plate_color',
          storeOptions: 'plateColorType',
          getName: true,
          label: '车牌颜色',
        },
        {
          type: 'select',
          field: 'color_id',
          label: '车辆颜色',
          storeOptions: 'vehicleColorType',
        },
        {
          type: 'input',
          field: 'vehicle_license_number',
          label: '车辆识别代号',
        },
        {
          type: 'input',
          field: 'engine_number',
          label: '发动机号码',
        },
        {
          type: 'radio',
          field: 'cargo_type',
          options: constantToOptions(cargoType),
          label: '货物类型',
          hidden: !showCargo.value,
          onChange: cargoTypeChange,
        },
        {
          type: 'input',
          field: 'cargo_name',
          label: '货物名称',
          hidden: !showCargo.value,
        },
        {
          type: 'input',
          field: 'car_load',
          label: '载重(吨)',
          hidden: !showCargo.value,
        },
        {
          type: 'input',
          field: 'remark',
          label: '备注',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'vehicle_img',
          label: '车辆照片',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'img12123',
          label: '12123交警平台截图',
          number: 20,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'blind_video_photo',
          label: '盲区监控视频图片',
          number: 20,
          required: false
          //hidden: need_record.value != 1,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'register_record_photo',
          label: '备案车辆信息登记表图片',
          number: 20,
          hidden: !props.canEdit ? detailNeedRecord.value : need_record.value != 1 ,
        },
      ],
    },
    {
      name: '危险品货物清单',
      id: 'cargo_info',
      submitInObject: true,
      hidden: !showCargo.value || !showDanger.value,
      dataInObject: 'cargo_info',
      formItem: [
        {
          type: 'input',
          field: 'cargo_number',
          label: '运单编号',
        },
        {
          type: 'input',
          field: 'cargo_quantity',
          label: '货物数量（计数单位）',
        },
        {
          type: 'input',
          field: 'enterprise',
          label: '企业名称(承运方)',
        },
        {
          type: 'input',
          field: 'unified_social_credit_code',
          label: '统一信用代码(承运方)',
        },
        {
          type: 'input',
          field: 'business_license_number',
          label: '承运人经营许可证号',
        },
        {
          type: 'input',
          field: 'contact_phone',
          label: '承运人联系电话',
        },
        {
          type: 'input',
          field: 'vehicle_transport_license',
          label: '车辆道路运输证号',
        },
        {
          type: 'input',
          field: 'trailer_license',
          label: '挂车号牌',
        },
        {
          type: 'input',
          field: 'trailer_trasport_license',
          label: '挂车道路运输证号',
        },
        {
          type: 'input',
          field: 'driver',
          label: '驾驶员姓名',
        },
        {
          type: 'input',
          field: 'driver_qualification_certificate',
          label: '驾驶员从业资格证号',
        },
        {
          type: 'input',
          field: 'driver_phone',
          label: '驾驶员联系电话',
        },
        {
          type: 'input',
          field: 'supercargo',
          label: '押运员姓名',
        },
        {
          type: 'input',
          field: 'supercargo_qualification_certificate',
          label: '押运员从业资格证号',
        },
        {
          type: 'input',
          field: 'supercargo_phone',
          label: '押运员联系电话',
        },
        {
          type: 'input',
          field: 'shipper',
          label: '托运人姓名',
        },
        {
          type: 'input',
          field: 'shipper_phone',
          label: '托运人联系电话',
        },
        {
          type: 'input',
          field: 'recipient',
          label: '收货人姓名',
        },
        {
          type: 'input',
          field: 'recipient_phone',
          label: '收货人联系电话',
        },
        {
          type: 'input',
          field: 'carrier',
          label: '装货人姓名',
        },
        {
          type: 'input',
          field: 'carrier_phone',
          label: '装货人联系电话',
        },
        {
          type: 'date',
          field: 'shipment_date',
          label: '起运日期',
        },
        {
          type: 'input',
          field: 'shipment_addr',
          label: '起运地',
        },
        {
          type: 'input',
          field: 'destination',
          label: '目的地',
        },
        {
          type: 'inputNumber',
          field: 'tank_volume',
          label: '罐体容积'
        },
        {
          type: 'fileUpload',
          field: 'annex',
          // number: 99,
          label: '运单附件',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'tank_report',
          label: '运单附件',
        },
      ],
    },
    {
      name: '来访信息',
      id: 'visiting_information',
      formItem: [
        {
          type: 'select',
          field: 'visit_area',
          label: '申请园区',
          // storeOptions: 'areaType',
          options: constantToOptions(areaTypeConst),
        },
        {
          type: 'radio',
          storeOptions: 'carVisitType',
          field: 'visitor_type',
          label: '申请类型',
          tips: [
            '施工车辆访问时间不能超过一个月，通行时间段为9:00-18:00！ ',
            '维修车辆访问时间不能超过一个月，通行时间段为9:00-18:00！',
            '临时车辆访问时间不能超过三天，通行时间段为9:00-18:00！',
            '业主车辆访问时间不能超过一年',
          ],
        },
        {
          type: 'input',
          field: 'interviewee_name',
          label: '被访问人',
        },
        {
          type: 'input',
          field: 'interviewee_phone',
          label: '被访问人电话',
        },
        {
          type: 'select',
          field: 'interviewee_depart_id',
          label: '被访问机构',
          storeOptions: 'dept',
        },
        {
          type: 'input',
          field: 'visitor_content',
          label: '来访事由',
        },
        {
          type: 'dateRange',
          startField: 'visitor_begin_time',
          endField: 'visitor_end_time',
          label: '来访时间',
          disabledDate(current, dayjs) {
            return current < dayjs().add(2, 'day').endOf('day')
          },
        },
      ],
    },
    {
      name: '驾乘人员信息',
      id: 'driver_info',
      dataIdFiled: 'car_person_id',
      dynamic: true,
      formItem: [
        {
          type: 'input',
          field: 'name',
          label: '姓名',
        },
        {
          type: 'select',
          field: 'idcard_type',
          storeOptions: 'documentType',
          label: '证件类型',
        },
        {
          type: 'input',
          field: 'id_card',
          label: '证件号',
        },
        {
          type: 'radio',
          field: 'gender',
          label: '性别',
          options: constantToOptions(gender),
        },
        {
          type: 'input',
          field: 'phone',
          label: '联系电话',
        },
        {
          type: 'radio',
          field: 'type',
          label: '驾乘分类',
          storeOptions: 'driverType',
          width: '400px'
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'face_photo',
          label: '人像照片',
        },
      ],
    },
  ])

  function cargoTypeChange(data) {
    if (data.target.value === '1') showDanger.value = true
    else showDanger.value = false
  }

  //提交
  async function handelSubmit(data) {
    const ajaxFn = props.isEdit ? updateData : createData
    const messageText = props.isEdit ? '编辑' : '创建'
    const id = props.isEdit
      ? { [props.idField]: props.editData[props.idField] }
      : {}
    const filteredData = filterData(data, !showCargo.value, [
      'car_load',
      'cargo_name',
      'cargo_type',
      'cargo_info',
    ])
    
    if (Array.isArray(filteredData.img12123)) {
      filteredData.img12123 = filteredData.img12123?.map(item => item.url)?.join(';');
    }
    if (Array.isArray(filteredData.blind_video_photo)) {
      filteredData.blind_video_photo = filteredData.blind_video_photo?.map(item => item.url)?.join(';');
    }
    if (Array.isArray(filteredData.register_record_photo)) {
      filteredData.register_record_photo = filteredData.register_record_photo?.map(item => item.url)?.join(';');
    }
    const res = await ajaxFn({ ...filteredData, ...id })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }

  function filterData(data, doFilter, fields) {
    let newData = JSON.parse(JSON.stringify(data))
    if (doFilter) {
      fields.forEach((item) => delete newData[item])
      return newData
    }
    return data
  }

  //批量导入
  function bulkImportSuccess() {
    message.success('批量导入成功！')
    emit('submit')
  }
  function bulkImportError(e) {
    message.warn(
      e.data
        ? e.data.reduce((pre, now, index) => {
            return `${pre}${pre && '；'}
            ${now}`
          }, '')
        : e.msg,
      10
    )
  }
</script>
<style scoped lang="less">
  .tool_box {
    display: flex;
    justify-content: flex-end;
  }
</style>
